export const DELETE_CONFIRMATION_MODAL_TEXT = {
	defaultTitle: 'Are you sure you want to delete this item?',
	defaultDescription:
		'Deleting this item will remove it permanently. This action cannot be undone. Proceed with caution.',
	defaultItemLabel: 'item',
	cancelButton: 'Cancel',
	confirmButton: 'Delete',
	deletePrefix: 'Deleting this',
	deleteEffect: 'will remove it permanently. This action cannot be undone.',
	proceedWithCaution: 'Proceed with caution.',
};
